//state management for blog page was complex enough to to justify utilizing its own context
//otherwise would have required unwieldy degree of passing props through components manually

import { createContext, useContext, useEffect, useCallback, useState, useMemo, useRef, useReducer } from 'react'
import { useLocation } from 'react-router-dom'; 
import useFetch from '#Hooks/Fetch'
import useControlledInput from '#Hooks/InputControl'

const BlogContext = createContext();

export default function useBlogContext() {
    return useContext(BlogContext)
}

export function BlogProvider({ children }) {
    //STATE FOR SEARCH FORM
    const blogSearchFormRef = useRef(null);
    let [textQueryProps, resetTextQuery] = useControlledInput('');
    let [filterProps, resetFilter] = useControlledInput('Date'); //rating, views, or Date

    //for handling boundary/suspense integration with search
    const articleListFetchProps = useFetch('blog1', 2000) //extra added delay to demo Suspense
    const [getArticles, status, articleList] = articleListFetchProps; //pedagogical
    const submitSearch = useCallback(e => {
        e.preventDefault();
        e.stopPropagation();
        let searchParams = new URLSearchParams({
            text: textQueryProps.value,
            sort: filterProps.value.toLowerCase()
        })
        getArticles(`/api/blog/list?${searchParams.toString()}`);
        resetTextQuery();
        resetFilter();
    }, [textQueryProps.value, filterProps.value])

    //ARTICLE COMPOSITION MODE
    //SHOULD COME BACK AT SOME POINT AND MAKE PRIVATE //use NODE_ENV check on whether to render that route
    const location = useLocation();
    const constructing = useMemo(() => {
        const segments = location.pathname.split('/')
        return segments[segments.length - 1] === 'Constructor'
    }, [location])
    const [constructedData, collectConstructedData] = useReducer(constructionReducer, null);
    const submitArticle = useCallback(e => {
        fetch('/api/blog/submit', {
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json' }),
            body: JSON.stringify(constructedData),
        })
            .then(r => r.json())
            .then(r => { console.log(r) })
    }, [constructedData])
    const construction = {
        //collect pieces of state in a single object
        constructing,
        constructedData,
        collectConstructedData, 
        submitArticle
    }

    const viewArticleRequest = useCallback((errorFlag, url, options) => {
        // custom function passed to useFetch Hook, 
        // needed to deal with situation when constructing a new article and querying for permalink would return 404, don't want to error out!
        return fetch(url, options)
            .then(r => {
                if (!r.ok) {
                    if (r.status === 404 && constructing) {
                        //bypassing error handling when constructing a new article
                        return null
                    }
                    else errorFlag.current = { status: r.status }
                }
                let type = r.headers.get("Content-Type").split(';')[0] //header also had charset info I don't care about
                if (type === 'application/json') return r.json();
                else throw new Error(`Status: ${r.status} - Got unexpected Content-Type: ${type}`)
            })
    }, [constructing])

    //FOR RETRIEVING CURRENTLY VIEWING ARTICLE
    const currentArticleFetchProps = useFetch('blog2', 1500, viewArticleRequest)

    return (
        <BlogContext.Provider value={{
            blogSearchFormRef,
            textQueryProps,
            filterProps,
            submitSearch,
            construction,
            articleListFetchProps,
            currentArticleFetchProps,
        }}>
            {children}
        </BlogContext.Provider>
    )
}

function constructionReducer(oldState, update) {
    if (!update.articleBodyNode) {
        throw new Error('Article Body Node not specified')
    }
    let bodyText = collectBodyText(update.articleBodyNode, []); 
    delete update.articleBodyNode; 
    return {...update, bodyText}
}

function collectBodyText(DomNode, paragraphs) {
    // DOM node attribute .textContent didn't separate text content from different child elements 
    // with any spacing, using this include that separation to enable proper text-indexing
    //recursive function adapted from JavaScript The Definitive Guide by David Flanagan, p444
    // let bodyText = "+" 
    for (let child = DomNode.firstChild; child !== null; child = child.nextSibling){
        let type = child.nodeType; 
        if (type === 3) {
            // bodyText += child.nodeValue
            paragraphs.push(child.nodeValue)
        }
        else if (type === 1) {
            collectBodyText(child, paragraphs)
        }
    }
    return paragraphs
}


